import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { clearAccessTokens, getAccessToken } from '@/api/tokens.helper';
import { isAccessTokenValid } from '@/auth/jwt';
import { ROUTES } from '@/router/routes';

export const RequireAuth = ({ children }: { children: ReactNode }) => {
  const token = getAccessToken();

  if (!isAccessTokenValid(token)) {
    if (token) {
      clearAccessTokens();
    }
    return <Navigate to={ROUTES.UNAUTHORIZED} replace />;
  }

  return <>{children}</>;
};
